// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchSlice_wrapper__68000","autoSuggest":"SearchSlice_autoSuggest__fd114","searchInput":"SearchSlice_searchInput__39dbd","code":"SearchSlice_code__46597"};